"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PaginateArrows = _interopRequireDefault(require("../PaginateArrows"));

require("../assets/css/font-face.css");

require("./Paginate.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Paginate = function Paginate(_ref) {
  var currentPage = _ref.currentPage,
      perPage = _ref.perPage,
      count = _ref.count,
      onClick = _ref.onClick,
      noBorder = _ref.noBorder;

  var _useState = (0, _react.useState)(currentPage),
      _useState2 = _slicedToArray(_useState, 2),
      current = _useState2[0],
      setCurrent = _useState2[1];

  var interval = 7;
  var pagesTotal = count % perPage > 0 ? parseInt(count / perPage) + 1 : count / perPage;

  var renderPagesList = function renderPagesList() {
    if (pagesTotal === 1) return null;

    if (pagesTotal <= 7) {
      return _toConsumableArray(Array(pagesTotal)).map(function (e, i) {
        return renderPageNumber(i + 1);
      });
    }

    return _react.default.createElement(_react.default.Fragment, null, renderPageNumber(1), _toConsumableArray(Array(interval)).map(function (e, i) {
      var page; // makes the current page increase without center the number in the begin
      // istanbul ignore else

      if (current < interval) {
        page = i + 2;
      } // make the current page stay centered
      // istanbul ignore else


      if (current >= interval && current + 3 <= pagesTotal) {
        page = current - 3 + i;
      } // makes the current page increase without center the number in the end
      // istanbul ignore else


      if (current + 3 >= pagesTotal) {
        page = pagesTotal - interval + i;
      }

      return renderPageNumber(page);
    }), renderPageNumber(pagesTotal));
  };

  var renderPageNumber = function renderPageNumber(page) {
    var pageClass = 'paginate__page';
    if (current === page) pageClass += ' paginate__page--active';
    return _react.default.createElement(_react.default.Fragment, {
      key: page
    }, page === pagesTotal && current < pagesTotal - 4 && _react.default.createElement("span", {
      className: "paginate__page paginate__page--ellipsis"
    }, "..."), _react.default.createElement("span", {
      onClick: function onClick() {
        return onClickPage(page);
      },
      className: pageClass
    }, page), page === 1 && current > interval - 1 && _react.default.createElement("span", {
      className: "paginate__page paginate__page--ellipsis"
    }, "..."));
  };

  var onClickPage = function onClickPage(page) {
    if (page === current) return;
    setCurrent(page);
    onClick(page);
  };

  var wrapperClass = 'paginate';
  if (noBorder) wrapperClass += ' paginate--noborder';
  return _react.default.createElement("div", {
    className: wrapperClass
  }, _react.default.createElement(_PaginateArrows.default, {
    currentPage: current,
    totalItems: count,
    perPage: perPage,
    onClick: function onClick(value) {
      return onClickPage(value);
    }
  }), _react.default.createElement("div", null, renderPagesList()));
};

Paginate.defaultProps = {
  onClick:
  /* istanbul ignore next */
  function onClick() {}
};
Paginate.propTypes = {
  /** Página atual */
  currentPage: _propTypes.default.number,

  /** Total de páginas */
  count: _propTypes.default.number,

  /** Total de registros por página */
  perPage: _propTypes.default.number,

  /** Callback executada ao selecionar uma página ou clicar em Next/Prev */
  onClick: _propTypes.default.func
};
var _default = Paginate;
exports.default = _default;